import { equipmentsService } from "@/apis/services"
import { IEquipment, IPaginationMeta, IPaginationParamV2 } from "@/types"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface IEquipmentState {
  equipments: IEquipment[]
  currentEquipment: IEquipment | null
  meta?: IPaginationMeta
  isLoading: boolean
  error: string | null
  fetchEquipments: (params: IPaginationParamV2) => Promise<void>
}

const initialState = {
  equipments: [],
  currentEquipment: null,
  meta: undefined,
  isLoading: false,
  error: null,
}

export const useEquipmentsStore = create<IEquipmentState>()(
  devtools(set => ({
    ...initialState,
    fetchEquipments: async (params: IPaginationParamV2) => {
      set({ isLoading: true, error: null })
      try {
        const response = await equipmentsService.getEquipments(params)
        set({ equipments: response.data.items, meta: response.data.meta })
      } catch (error) {
        const errorMessage: string = error instanceof Error ? error.message : "An unknown error occurred"
        set({ error: errorMessage })
        throw error
      } finally {
        set({ isLoading: false })
      }
    },
  }))
)
